import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';
const {
  GET_ALL_PATIENT_LIST_REQUEST,
  GET_ALL_PATIENT_LIST_SUCCESS,
  GET_ALL_PATIENT_LIST_FAILURE,
  GET_ALL_PATIENT_LIST_LOADING,
  GET_ALL_PATIENT_LIST_RESET,
} = patientAction;

function* getPatientListRecord(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_PATIENT_LIST_LOADING });
    const response = yield call(patientService.getPatientRecord, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PATIENT_LIST_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PATIENT_LIST_FAILURE, payload: error });
  }
}

function* getPatientListRecordSaga() {
  yield takeEvery(GET_ALL_PATIENT_LIST_REQUEST, getPatientListRecord);
}

export default getPatientListRecordSaga;
